import { AnyString } from "../utility";

export const resourceType = {
  Anchors: "anchors",
  Assets: "assets",
  Devices: "devices",
  Spaces: "spaces",
  SpaceInfo: "counts",
  Trackers: "trackers",
  Permits: "permits",
  AppInstances: "app_instances",
  Users: "console_users",
  Zones: "zones",
  Sites: "sites",
  ZoneMarkers: "markers",
  TrackerHistory: "tracker_history",
  Sensors: "sensors",
  AggregatedSensors: "aggregated_sensors",
  AggregatedPresence: "aggregated_presence"
} as const;

export type ResourceType = (typeof resourceType)[keyof typeof resourceType] | AnyString;

export const resourceTypeToSupabaseResource = (resource: ResourceType) => {
  switch (resource) {
    case resourceType.Anchors:
      return "anchors";
    case resourceType.Assets:
      return "assets";
    case resourceType.Devices:
      return "devices";
    case resourceType.Spaces:
      return "workspaces";
    case resourceType.SpaceInfo:
      return "counts";
    case resourceType.Trackers:
      return "trackers";
    case resourceType.Permits:
      return "permits";
    case resourceType.Users:
      return "users";
    case resourceType.AppInstances:
      return "instances";
    case resourceType.Zones:
      return "zones";
    case resourceType.Sites:
      return "sites";
    case resourceType.Sensors:
      return "sensors";
    default:
      throw new Error(`Unknown resource type: ${resource}`);
  }
};

export const resourceTypeToSupabaseCountResource = (resource: ResourceType) => {
  switch (resource) {
    case resourceType.Anchors:
      return "anchors_count";
    case resourceType.Assets:
      return "assets_count";
    case resourceType.Devices:
      return "devices_count";
    case resourceType.Trackers:
      return "trackers_count";
    case resourceType.AppInstances:
      return "instances_count";

    default:
      throw new Error(`Unknown count resource type: ${resource}`);
  }
};
